/**
 * SIRH ACTION
 */

export const integrationFetchLuccaOptions = () => ({
  type : 'API',
  payload : {
    method : "GET",
    url : "/integration/lucca/options"
  }
})

export const integrationFetchLuccaUsers = () => ({
  type : 'API',
  payload : {
    method : "GET",
    url : "/integration/lucca/users"
  }
})

//Initial sync of the users from the Entra ID directory (Cryptr)
export const integrationSyncEntra = () => ({
  type : 'API',
  payload : {
    method : "POST",
    url : "/integration/entra/sync"
  }
})

export const integrationFetchMondayDeals_AsSupervisor = () => ({
  type : 'API',
  payload : {
    method : "GET",
    url : "/supervisor/integration/monday/deals"
  }
})

//Ignore a Monday deal (hidden from the accounts board) or show it again
export const integrationIgnoreMondayDeal_AsSupervisor = (dealId: string, isIgnored: boolean) => ({
  type : 'API',
  payload : {
    method : "POST",
    url : "/supervisor/integration/monday/deal/ignore",
    data : {
      dealId,
      isIgnored
    }
  }
})
